"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.embed = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const app_error_1 = __importDefault(require("src/components/app-error"));
const root_1 = require("src/utils/root");
const embed_styles_1 = __importDefault(require("./embed.styles"));
const i18n = (0, pythia_libs_1.i18n)(['errors', 'page']);
// eslint-disable-next-line import/prefer-default-export
const embed = (Component, componentProps = {}) => {
    const rootService = (0, root_1.getRootService)(componentProps.root);
    const root = rootService.get();
    try {
        react_dom_1.default.render((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: embed_styles_1.default }), (0, jsx_runtime_1.jsx)(Component, Object.assign({}, componentProps, { rootService: rootService }))] }), root);
    }
    catch (e) {
        console.error('e', e);
        react_dom_1.default.render((0, jsx_runtime_1.jsx)(app_error_1.default, { message: i18n(['default']) }), root);
        throw e;
    }
};
exports.embed = embed;
